/* eslint semi: 1 */
import _ from 'lodash';

/**
 * Generic permissions check to access Create experience
 * @param {currentUser} - non-empty `current-user-info` instance
 */
export const hasPermissionToCreate = (currentUser) => {
  const hasSubRightsToCreate = currentUser.hasGroupUserCreate() || currentUser.hasUserRightAdmin();
  const hasSubRightsNotAllowedToCreate = currentUser.hasGroupUserCreateLock();

  return hasSubRightsToCreate && !hasSubRightsNotAllowedToCreate;
};

/**
 * Generic permissions check to access a resource.
 * @param {currentUser} - non-empty `current-user-info` instance
 * @param {targetTags} - list of tags (`player-data-canvas`/tagsToCanvas) with `inline` attribute present. Could be empty.
 * @returns boolean
 */
export const hasPermissionToAccess = (currentUser, targetTags) => {
  const hasSubRightsToAccess = (
    currentUser.hasGroupUserCreate() ||
    currentUser.hasGroupUserSchedule() ||
    currentUser.hasGroupUserCreateLock() ||
    currentUser.hasUserRightAdmin()
  );

  const userAssignedResourceTags = currentUser.getUserTags() ?? [];
  const isUserHasAssignedResourceTags = !_.isEmpty(userAssignedResourceTags);

  if (hasSubRightsToAccess && !isUserHasAssignedResourceTags) {
    return true;
  } else
    // shouldn't work for Premium/Videowall
    if (!_.isEmpty(targetTags) && hasSubRightsToAccess && isUserHasAssignedResourceTags) {
      // there's at least one tag which intersects with the targetTags[].inline
      return !_.isUndefined(
        targetTags.find(
          tag => !_.isEmpty(_.intersection(tag.inline, userAssignedResourceTags))
        )
      );
    }

  return false;
};

/**
 * Generic permissions check to publish to player
 * @param {currentUser} - non-empty `current-user-info` instance
 */
export const hasPermissionToPublishToPlayer = (currentUser, isAlertPage) => {
  /**
   * If the acount being used is discovery, allow permission to publish to player
   */
  if (currentUser.isStandAloneUser() || currentUser.isFreeUser()) {
    return true;
  }

  /**
   * Invited users should not have access to the schedule page and cannot publish to the player unless they have schedule rights. However, users with alert rights can publish to the player only from the alert page.
   */
  const isUserHasAlertRightAndIsAlertPage = currentUser.hasGroupUserAlert() && isAlertPage;
  if (!currentUser.hasUserRightAdmin() && currentUser.isSubUser() && !currentUser.hasGroupUserSchedule() && !isUserHasAlertRightAndIsAlertPage) {
    return false;
  }

  return true;
};
